import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { useTemplatesStudio } from 'api/useTemplatesStudio';
import { TemplateStudioModel } from 'common/contracts';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { TemplatesStudioActivateDialog } from './Components/ActivateDialog';
import { TemplatesStudioDeleteDialog } from './Components/DeleteDialog';
import { TemplatesStudioMainPageHeader } from './Components/Header';
import { TemplateCard } from './Components/TemplateCard';

export const TemplatesStudioMainPage: React.FC = () => {
  const { templateIdToActivate, templateIdToDelete } = useTemplateStudioState();

  const { publisherId } = useParams();
  const { getTemplates } = useTemplatesStudio(publisherId);

  const templates: TemplateStudioModel[] = useMemo(() => {
    if (!getTemplates.data) return [];

    return [...getTemplates.data].sort((a, b) => {
      if (a.isActive === b.isActive) return 0;
      return a.isActive ? -1 : 1;
    });
  }, [getTemplates.data]);

  const isActivateDialogOpen = useMemo(
    () => !!templateIdToActivate,
    [templateIdToActivate]
  );

  const isDeleteDialogOpen = useMemo(
    () => !!templateIdToDelete,
    [templateIdToDelete]
  );

  return (
    <div className="overflow-y-scroll px-7 pb-11">
      <TemplatesStudioMainPageHeader />
      <div className="flex flex-col gap-4">
        {templates.map((template) => (
          <TemplateCard key={template.templateId} template={template} />
        ))}
      </div>
      {isActivateDialogOpen && <TemplatesStudioActivateDialog />}
      {isDeleteDialogOpen && <TemplatesStudioDeleteDialog />}
    </div>
  );
};
